<!-- CAD Toolbar - Modular Floating Panel -->
<div class="cad-toolbar" [class.floating]="position === 'floating'" [class.edit-mode]="isEditMode"
  [class.minimized]="!isEditMode">
  <!-- Processing Overlay -->
  @if (isProcessing) {
    <div class="processing-overlay">
      <div class="processing-content">
        <app-spinner type="simple" size="sm"></app-spinner>
        <span class="processing-text">{{ processingMessage }}</span>
        @if (processingProgress > 0) {
          <app-progress-bar
            [value]="processingProgress"
            [max]="100"
            class="processing-progress">
          </app-progress-bar>
        }
      </div>
    </div>
  }

  <!-- Edit Mode Content -->
  @if (isEditMode) {
    <div class="toolbar-body">
      <div class="alpha-badge">BETA</div>
      <!-- Quick Actions Bar -->
      <div class="quick-actions">
        <!-- Transform Mode -->
        <button class="quick-btn" [class.active]="transformMode === 'translate'" (click)="setTransformMode('translate')"
          appTooltip="Move (Q)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M5 9l-3 3 3 3M9 5l3-3 3 3M15 19l-3 3-3-3M19 9l3 3-3 3M2 12h20M12 2v20" />
          </svg>
          <span class="key-hint">Q</span>
        </button>
        <button class="quick-btn" [class.active]="transformMode === 'rotate'" (click)="setTransformMode('rotate')"
          appTooltip="Rotate (W)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M21 12a9 9 0 1 1-6.219-8.56" />
            <path d="M21 3v6h-6" />
          </svg>
          <span class="key-hint">W</span>
        </button>
        <button class="quick-btn" [class.active]="transformMode === 'scale'" (click)="setTransformMode('scale')"
          appTooltip="Scale (E)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <!-- Corner arrows pointing outward (scale/resize icon) -->
            <path d="M15 3h6v6" />
            <path d="M9 21H3v-6" />
            <path d="M21 3l-7 7" />
            <path d="M3 21l7-7" />
          </svg>
          <span class="key-hint">E</span>
        </button>
        <div class="quick-divider"></div>
        <!-- Snap -->
        <button class="quick-btn" [class.active]="snapEnabled" (click)="toggleSnap()" appTooltip="Grid Snap">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <rect x="3" y="3" width="7" height="7" />
            <rect x="14" y="3" width="7" height="7" />
            <rect x="14" y="14" width="7" height="7" />
            <rect x="3" y="14" width="7" height="7" />
          </svg>
        </button>
        <!-- Undo / Redo -->
        <button class="quick-btn" [disabled]="!canUndo" (click)="undoHistory()" appTooltip="Undo (Ctrl/Cmd+Z)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M9 14l-4-4 4-4" />
            <path d="M5 10h7a5 5 0 1 1 0 10h-1" />
          </svg>
          <span class="key-hint">Z</span>
        </button>
        <button class="quick-btn" [disabled]="!canRedo" (click)="redoHistory()" appTooltip="Redo (Ctrl/Cmd+Y)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M15 6l4 4-4 4" />
            <path d="M19 10h-7a5 5 0 1 0 0 10h1" />
          </svg>
          <span class="key-hint">Y</span>
        </button>
        <div class="quick-divider"></div>
        <!-- Parallel Constraint -->
        <!-- <button
        class="quick-btn constraint-btn"
        [class.active]="constraintMode === 'parallel'"
        (click)="toggleParallelConstraint()"
        [disabled]="drawingMode === 'none'"
        appTooltip="Parallel Constraint (draw parallel to nearest edge)">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="4" y1="6" x2="20" y2="6" />
          <line x1="4" y1="18" x2="20" y2="18" />
        </svg>
      </button> -->
      <!-- Perpendicular Constraint -->
      <!-- <button
      class="quick-btn constraint-btn"
      [class.active]="constraintMode === 'perpendicular'"
      (click)="togglePerpendicularConstraint()"
      [disabled]="drawingMode === 'none'"
      appTooltip="Perpendicular Constraint (draw perpendicular to nearest edge)">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="6" y1="4" x2="6" y2="20" />
        <line x1="6" y1="12" x2="20" y2="12" />
        <rect x="6" y="12" width="4" height="4" fill="currentColor" opacity="0.3" />
      </svg>
    </button> -->
    <!-- <div class="quick-divider"></div> -->
    <!-- Delete -->
    <button class="quick-btn danger" [disabled]="selectedCADShapeIds.size === 0" (click)="confirmDeleteSelected()"
      appTooltip="Delete (Del)">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      </svg>
      <span class="key-hint">Del</span>
    </button>
    <div class="quick-divider"></div>
    <!-- Exit CAD Editor -->
    <button class="quick-btn exit-btn" (click)="exitEditor()" appTooltip="Exit CAD Editor">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <polyline points="16 17 21 12 16 7" />
        <line x1="21" y1="12" x2="9" y2="12" />
      </svg>
    </button>
  </div>
  <!-- Main Action Buttons -->
  <div class="main-actions">
    <app-button [variant]="activePanel === 'create' ? 'primary' : 'ghost'" size="sm" [flex]="true"
      [active]="activePanel === 'create'" (click)="togglePanel('create')">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width: 14px; height: 14px">
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
      </svg>
      Add Shape
    </app-button>
    <app-button [variant]="activePanel === 'operations' ? 'primary' : 'ghost'" size="sm" [flex]="true"
      [active]="activePanel === 'operations'" [disabled]="selectedCADShapeIds.size === 0"
      (click)="togglePanel('operations')">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="width: 14px; height: 14px">
        <circle cx="9" cy="12" r="5" />
        <circle cx="15" cy="12" r="5" />
      </svg>
      Modify
      @if (selectedCADShapeIds.size > 0) {
        <span class="count-badge">{{ selectedCADShapeIds.size }}</span>
      }
    </app-button>
    <app-button [variant]="activePanel === 'history' ? 'primary' : 'ghost'" size="sm" [flex]="true"
      [active]="activePanel === 'history'" (click)="togglePanel('history')">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="width: 14px; height: 14px">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v6l4 2" />
      </svg>
      History
    </app-button>
  </div>
  <!-- Isolation Mode Indicator -->
  @if (isIsolateMode) {
    <div class="isolation-indicator">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10" />
        <circle cx="12" cy="12" r="4" />
      </svg>
      <span>Isolate Mode</span>
      <button class="exit-isolate-btn" (click)="showAllShapes()" appTooltip="Show All Shapes">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  }
  <!-- Sketch Browser -->
  @if (showSketchBrowser) {
    <div class="sketch-browser-section">
      <sketch-browser [isSketchMode]="isSketchMode" [selectedProfileIds]="selectedProfileIds" (onCreate)="onCreateNewSketch()" (onSketchSelect)="onSketchSelected($event)"
        (onEntitySelect)="onSketchEntitySelected($event)" (onProfileSelect)="onSketchProfileSelected($event)"
        (onEdit)="onEditSketch($event)" (onDelete)="onDeleteSketch($event)"
        (onEntityDelete)="onDeleteSketchEntity($event)" (onNodeHovered)="onSketchBrowserNodeHovered($event)"
        (onVisibilityToggle)="onSketchVisibilityToggle($event)" (onFinishEditing)="finishSketchEditing()">
      </sketch-browser>
      <!-- Entity Selection Section (when in sketch editing mode) -->
      @if (isSketchMode && activeSketch && activeSketch.entities.length > 0) {
        <div class="sketch-mode-actions">
          <div class="entity-selection-section">
            <div class="entity-selection-header">
              <span class="entity-label">Shapes</span>
              <span class="entity-count">{{ activeSketch.entities.length }} shapes</span>
            </div>
            @if (getSelectedSketchEntityCount() > 0) {
              <div class="entity-info">
                <span class="selection-text">{{ getSelectedSketchEntityCount() }} selected</span>
                <button class="delete-entities-btn" (click)="deleteSelectedSketchEntities()"
                  appTooltip="Delete selected (Del)">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="3 6 5 6 21 6" />
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                  </svg>
                  Delete
                </button>
              </div>
            }
            @if (getSelectedSketchEntityCount() === 0) {
              <div class="entity-tip">
                Click shapes to select • Ctrl+click for multi-select
              </div>
            }
          </div>
        </div>
      }
      <!-- Extrusion Panel (outside sketch mode, when profiles available) -->
      @if (activeSketch && selectedProfileIds.size > 0) {
        <div class="extrusion-panel">
          <div class="extrusion-settings">
            <!-- Height Input Row -->
            <div class="extrusion-row">
              <button class="direction-btn" [class.active]="extrudePositive" (click)="setExtrudeDirection('positive')"
                appTooltip="Extrude up (+)">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                  style="width: 12px; height: 12px">
                  <path d="M12 19V5M5 12l7-7 7 7" />
                </svg>
              </button>
              <app-form-control label="Height" class="flex-grow">
                <app-input type="number" size="xs" [(ngModel)]="extrudeHeight" [step]="5"></app-input>
              </app-form-control>
              <button class="direction-btn" [class.active]="!extrudePositive" (click)="setExtrudeDirection('negative')"
                appTooltip="Extrude down (-)">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                  style="width: 12px; height: 12px">
                  <path d="M12 5v14M5 12l7 7 7-7" />
                </svg>
              </button>
            </div>
          </div>
          <!-- Hint shown when profiles are selected (drag mode is auto-active) -->
          @if (selectedProfileIds.size > 0) {
            <p class="extrusion-hint">
              Drag on canvas to set height • Press Enter to apply
            </p>
          }
          <app-button variant="primary" size="sm" [flex]="true"
            [disabled]="selectedProfileIds.size === 0" (click)="extrudeSelectedProfiles()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
              style="width: 16px; height: 16px">
              <path d="M12 2v10M12 12l4-4M12 12l-4-4M4 14v6h16v-6" />
            </svg>
            Extrude {{ selectedProfileIds.size }} Profile{{ selectedProfileIds.size !== 1 ? 's' : '' }}
          </app-button>
        </div>
      }
    </div>
  }
  <!-- Bodies Browser (Same style as models.component) -->
  <div class="bodies-browser" [class.disabled]="isSketchMode">
    <!-- Header -->
    <div class="bodies-header">
      <span class="bodies-header__title">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path
            d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
          <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
          <line x1="12" y1="22.08" x2="12" y2="12" />
        </svg>
        Bodies
      </span>
      <span class="bodies-header__count">({{ cadShapes.length }})</span>
      @if (selectedCADShapeIds.size > 0 && !isSketchMode) {
        <span class="bodies-header__selected">{{ selectedCADShapeIds.size }} selected</span>
      }
      <button class="add-body-btn" (click)="togglePanel('add-body')" [class.active]="activePanel === 'add-body'" appTooltip="Add Body">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="12" y1="5" x2="12" y2="19" />
          <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
      </button>
    </div>
    <!-- Bodies List -->
    @if (cadShapes.length > 0) {
      <div class="bodies-list">
        @for (shape of cadShapes; track shape; let i = $index) {
          <div class="bodies-list__item"
            [class.bodies-list__item--selected]="isCADShapeSelected(shape.id) && !isSketchMode"
            [class.bodies-list__item--hidden]="shape.isVisible === false"
            (click)="!isSketchMode && renamingShapeId !== shape.id && selectCADShapeFromList(shape.id, $event)"
            (dblclick)="!isSketchMode && startRenameShape(shape.id, $event)"
            (mouseenter)="!isSketchMode && onBodyListItemHover(shape.id)"
            (mouseleave)="!isSketchMode && onBodyListItemHover(null)"
            (contextmenu)="!isSketchMode && onShapeContextMenu($event, shape.id)">
            <div class="bodies-list__info">
              <div class="bodies-list__color" [style.background]="shape.color"></div>
              <div class="bodies-list__icon" appTooltip="3D Body">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <path
                    d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                </svg>
              </div>
              <div class="bodies-list__name-container">
                <!-- Normal display -->
                @if (renamingShapeId !== shape.id) {
                  <span class="bodies-list__name">
                    {{ shape.name || 'Body ' + (i + 1) }}
                  </span>
                }
                <!-- Editing input -->
                @if (renamingShapeId === shape.id) {
                  <input class="bodies-list__name-input" type="text"
                    [(ngModel)]="renamingShapeName" (blur)="saveShapeName()" (keydown.enter)="saveShapeName()"
                    (keydown.escape)="cancelRenameShape()" (click)="$event.stopPropagation()" />
                }
              </div>
            </div>
            <div class="bodies-list__actions">
              <!-- Visibility toggle -->
              @if (renamingShapeId !== shape.id) {
                <button class="action-btn visibility-btn"
                  [class.hidden]="shape.isVisible === false"
                  (click)="toggleShapeVisibility(shape.id, $event)"
                  [appTooltip]="shape.isVisible === false ? 'Show' : 'Hide'">
                  @if (shape.isVisible !== false) {
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                      <path d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                    </svg>
                  }
                  @if (shape.isVisible === false) {
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
                    </svg>
                  }
                </button>
              }
              <!-- Rename button -->
              @if (renamingShapeId !== shape.id) {
                <button class="action-btn rename-btn"
                  (click)="startRenameShape(shape.id, $event)" appTooltip="Rename">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                  </svg>
                </button>
              }
            </div>
          </div>
        }
      </div>
    }
    <!-- Empty State -->
    @if (cadShapes.length === 0) {
      <div class="bodies-empty">
        <div class="bodies-empty__title">No bodies</div>
        <div class="bodies-empty__subtitle">Create shapes or extrude sketches to add bodies.</div>
      </div>
    }
  </div>
  <!-- Section View Panel (hidden for Alpha) -->
  @if (false) {
  <div class="section-view-panel" [class.disabled]="isSketchMode">
    <div class="section-view-header" (click)="toggleSectionView()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
        <path d="M4 4h16v16H4z" />
        <path d="M4 12h16" stroke-dasharray="4 2" />
        <path d="M8 4v8M16 4v8" opacity="0.5" />
      </svg>
      <span>Section View</span>
      <div class="toggle-switch" [class.active]="sectionViewEnabled">
        <div class="toggle-knob"></div>
      </div>
    </div>
    @if (sectionViewEnabled) {
      <div class="section-view-controls">
        <!-- Axis Selection -->
        <div class="section-axis-selector">
          <button class="axis-btn" [class.active]="sectionPlaneAxis === 'x'" (click)="onSectionPlaneAxisChange('x')">X</button>
          <button class="axis-btn" [class.active]="sectionPlaneAxis === 'y'" (click)="onSectionPlaneAxisChange('y')">Y</button>
          <button class="axis-btn" [class.active]="sectionPlaneAxis === 'z'" (click)="onSectionPlaneAxisChange('z')">Z</button>
        </div>
        <!-- Position Slider -->
        <div class="section-position-slider">
          <label>Position</label>
          <input type="range" [min]="sectionPlaneMin" [max]="sectionPlaneMax" [step]="0.5"
            [ngModel]="sectionPlanePosition" (ngModelChange)="onSectionPlanePositionChange($event)" />
          <span class="position-value">{{ sectionPlanePosition | number:'1.1-1' }}</span>
        </div>
      </div>
    }
  </div>
  }
  <!-- Local Save/Load Section -->
  <div class="local-save-section">
    <div class="section-label">Local File</div>
    <div class="local-save-buttons">
      <button class="local-btn" [disabled]="cadShapes.length === 0 && sketchService.getAllSketches().length === 0"
        (click)="exportCADPartsToFile()" appTooltip="Export CAD data to JSON file">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="7 10 12 15 17 10" />
          <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
        <span>Export</span>
      </button>
      <button class="local-btn" [disabled]="cadShapes.length === 0"
        (click)="exportToSTEPFile()" appTooltip="Export to STEP file (CAD format)">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <path d="M9 15l3 3 3-3" />
          <line x1="12" y1="12" x2="12" y2="18" />
        </svg>
        <span>STEP</span>
      </button>
      <button class="local-btn" (click)="triggerCADPartsImport()" appTooltip="Import CAD parts from JSON file">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="17 8 12 3 7 8" />
          <line x1="12" y1="3" x2="12" y2="15" />
        </svg>
        <span>Import</span>
      </button>
      <button class="local-btn danger" [disabled]="cadShapes.length === 0" (click)="clearAllCADParts()"
        appTooltip="Clear all CAD parts">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <polyline points="3 6 5 6 21 6" />
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
        </svg>
        <span>Clear</span>
      </button>
    </div>
  </div>
  <!-- Project Save Section -->
  <div class="save-section">
    <div class="section-label">Project</div>
    @if (!isSaving) {
      <div class="save-button-wrapper">
        <app-button [variant]="hasUnsavedChanges ? 'ghost' : 'primary'" size="sm" [flex]="true"
          [disabled]="cadShapes.length === 0 && sketchService.getAllSketches().length === 0" (click)="saveCADParts()"
          [appTooltip]="hasUnsavedChanges ? 'Save to project' : 'All changes saved'">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
            style="width: 16px; height: 16px">
            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
            <polyline points="17 21 17 13 7 13 7 21" />
            <polyline points="7 3 7 8 15 8" />
          </svg>
          {{ hasUnsavedChanges ? 'Save to Project' : 'Saved' }}
        </app-button>
      </div>
    }
    @if (isSaving) {
      <div class="save-progress-wrapper">
        <div class="save-progress-bar">
          <div class="save-progress-fill" [style.width.%]="saveProgress"></div>
        </div>
        <span class="save-progress-text">{{ saveProgress | number: '1.0-0' }}%</span>
      </div>
    }
  </div>
</div>
}

<!-- ==================== FLYOUT PANELS ==================== -->

<!-- Create Panel (Flyout) -->
@if (isEditMode && activePanel === 'create') {
  <div class="flyout-panel create-panel" [@slideIn] [style.left]="toolbarLeft + 'px'">
    <div class="flyout-header">
      <span class="flyout-title">Add Shape</span>
      <app-button variant="icon-button" size="xs" (click)="closePanel()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width: 14px; height: 14px">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </app-button>
    </div>
    <div class="flyout-body">
      <!-- Sketch Section -->
      <div class="flyout-section">
        <div class="section-title">Sketch & Draw</div>
        <!-- Plane Selection -->
        <div class="plane-selector">
          <button class="plane-btn" [class.active]="sketchPlane === 'XY'"
            (click)="setSketchPlane(sketchPlane === 'XY' ? null : 'XY')">
            <span>XY</span>
          </button>
          <button class="plane-btn" [class.active]="sketchPlane === 'XZ'"
            (click)="setSketchPlane(sketchPlane === 'XZ' ? null : 'XZ')">
            <span>XZ</span>
          </button>
          <button class="plane-btn" [class.active]="sketchPlane === 'YZ'"
            (click)="setSketchPlane(sketchPlane === 'YZ' ? null : 'YZ')">
            <span>YZ</span>
          </button>
          <button class="plane-btn" [class.active]="sketchPlane === 'custom' || isFacePickingMode"
            [class.picking]="isFacePickingMode"
            (click)="isFacePickingMode ? stopFacePickingMode() : startFacePickingMode()">
            <span>{{ isFacePickingMode ? '...' : 'Face' }}</span>
          </button>
        </div>
        <!-- Plane Offset -->
        @if (sketchPlane && sketchPlane !== 'custom') {
          <div class="offset-row">
            <label>Offset</label>
            <app-input type="number" size="xs" [(ngModel)]="sketchPlaneOffset"
              (ngModelChange)="setSketchPlaneOffset($event)" [step]="5">
            </app-input>
            <span class="unit">{{ 'length' | unitLabel:unitSystem() }}</span>
          </div>
        }
        <!-- Face Info -->
        @if (sketchPlane === 'custom' && selectedFaceInfo) {
          <div class="face-info">
            <span class="face-tag">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="12" height="12">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              {{ selectedFaceInfo.sourceType === 'cad' ? 'CAD Face' : 'Assembly Face' }}
            </span>
            <button class="clear-btn" (click)="clearCustomPlane()">Clear</button>
          </div>
        }
        <!-- Face Picking Instructions -->
        @if (isFacePickingMode) {
          <div class="pick-instruction">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="14" height="14">
              <circle cx="12" cy="12" r="10" />
              <path d="M12 8v4M12 16h.01" />
            </svg>
            Click a face to select
          </div>
        }
        <!-- Sketch Tools -->
        @if (sketchPlane && !isFacePickingMode) {
          <div class="sketch-tools-section">
            <div class="sketch-tools-header">
              <span class="sketch-tools-title">Sketch Tools</span>
              <span class="sketch-plane-badge">{{ sketchPlane }}</span>
            </div>
            <!-- Basic Shapes Row -->
            <div class="sketch-tools-row">
              <button class="sketch-tool-btn" [class.active]="drawingMode === 'line'"
                (click)="setDrawingMode(drawingMode === 'line' ? 'none' : 'line')"
                appTooltip="Polyline - Click points, double-click or Enter to finish">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <polyline points="3 17 9 11 13 15 21 7" />
                </svg>
                <span>Line</span>
              </button>
              <button class="sketch-tool-btn" [class.active]="drawingMode === 'rectangle'"
                (click)="setDrawingMode(drawingMode === 'rectangle' ? 'none' : 'rectangle')"
                appTooltip="Rectangle - Click and drag corner to corner">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <rect x="3" y="3" width="18" height="18" rx="1" />
                </svg>
                <span>Rect</span>
              </button>
              <button class="sketch-tool-btn" [class.active]="drawingMode === 'circle'"
                (click)="setDrawingMode(drawingMode === 'circle' ? 'none' : 'circle')"
                appTooltip="Circle - Click center, drag to set radius">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <circle cx="12" cy="12" r="9" />
                </svg>
                <span>Circle</span>
              </button>
            </div>
            <!-- Advanced Shapes Row -->
            <div class="sketch-tools-row">
              <button class="sketch-tool-btn" [class.active]="drawingMode === 'arc'"
                (click)="setDrawingMode(drawingMode === 'arc' ? 'none' : 'arc')"
                appTooltip="3-Point Arc - Click start, mid, end points">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <path d="M4 20 Q 12 4 20 20" />
                </svg>
                <span>Arc</span>
              </button>
              <button class="sketch-tool-btn" [class.active]="drawingMode === 'polygon'"
                (click)="setDrawingMode(drawingMode === 'polygon' ? 'none' : 'polygon')"
                appTooltip="Polygon - Click center, drag to set size">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <polygon points="12,2 22,8.5 22,15.5 12,22 2,15.5 2,8.5" />
                </svg>
                <span>Polygon</span>
              </button>
              <button class="sketch-tool-btn" [class.active]="drawingMode === 'slot'"
                (click)="setDrawingMode(drawingMode === 'slot' ? 'none' : 'slot')"
                appTooltip="Slot - Click start and end, then set width">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <rect x="3" y="8" width="18" height="8" rx="4" />
                </svg>
                <span>Slot</span>
              </button>
            </div>
            <!-- Construction Mode Toggle -->
            <div class="sketch-tools-row construction-row">
              <button class="sketch-tool-btn construction-btn" [class.active]="isConstructionMode"
                (click)="toggleConstructionMode()"
                appTooltip="Toggle Construction Mode - Construction geometry guides drawing but doesn't create profiles">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-dasharray="4 2">
                  <line x1="3" y1="12" x2="21" y2="12" />
                  <line x1="12" y1="3" x2="12" y2="21" />
                </svg>
                <span>Construction</span>
              </button>
              @if (sketchService.getSelectedEntityIds().length > 0) {
                <button class="sketch-tool-btn"
                  (click)="toggleSelectedEntitiesConstruction()" appTooltip="Toggle construction for selected entities">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M4 4l16 16M4 20L20 4" stroke-dasharray="3 2" />
                  </svg>
                  <span>Toggle</span>
                </button>
              }
            </div>
            <!-- Polygon Settings (shown when polygon tool active) -->
            @if (drawingMode === 'polygon') {
              <div class="sketch-tool-settings">
                <div class="settings-row">
                  <label class="settings-label">Sides</label>
                  <div class="settings-input-group">
                    <button class="settings-stepper" (click)="decrementPolygonSides()">−</button>
                    <input type="number" class="settings-input" [(ngModel)]="polygonSides" min="3" max="24"
                      (keydown.enter)="$event.preventDefault()">
                    <button class="settings-stepper" (click)="incrementPolygonSides()">+</button>
                  </div>
                </div>
              </div>
            }
            <!-- Slot Settings (shown when slot tool active) -->
            @if (drawingMode === 'slot') {
              <div class="sketch-tool-settings">
                <div class="settings-row">
                  <label class="settings-label">Width</label>
                  <div class="settings-input-group">
                    <input type="number" class="settings-input wide" [(ngModel)]="slotWidth" min="1" step="0.5"
                      (keydown.enter)="$event.preventDefault()">
                    <span class="settings-unit">{{ 'length' | unitLabel:unitSystem() }}</span>
                  </div>
                </div>
              </div>
            }
          </div>
        }
        <!-- Drawing Status -->
        @if (drawingMode !== 'none') {
          <div class="sketch-status">
            <div class="status-indicator">
              <span class="status-dot"></span>
              @if (drawingMode === 'rectangle') {
                <span class="status-text">
                  {{ isDrawing ? 'Release to finish' : 'Click & drag corner' }}
                </span>
              }
              @if (drawingMode === 'circle') {
                <span class="status-text">
                  {{ isDrawing ? 'Release to set radius' : 'Click center point' }}
                </span>
              }
              @if (drawingMode === 'line') {
                <span class="status-text">
                  Points: {{ linePoints.length }} · Double-click or Enter to finish
                </span>
              }
              @if (drawingMode === 'arc') {
                <span class="status-text">
                  @switch (arcDrawingState.step) {
                    @case ('start') {
                      <span>Click start point</span>
                    }
                    @case ('mid') {
                      <span>Click arc midpoint</span>
                    }
                    @case ('end') {
                      <span>Click end point</span>
                    }
                  }
                </span>
              }
              @if (drawingMode === 'polygon') {
                <span class="status-text">
                  {{ isDrawing ? 'Drag to set size' : 'Click center point' }}
                </span>
              }
              @if (drawingMode === 'slot') {
                <span class="status-text">
                  @switch (slotDrawingState.step) {
                    @case ('start') {
                      <span>Click slot start</span>
                    }
                    @case ('end') {
                      <span>Click slot end</span>
                    }
                  }
                </span>
              }
            </div>
            <div class="status-actions">
              @if (drawingMode === 'line' && linePoints.length >= 3) {
                <app-button variant="primary" size="xs"
                  (click)="finishLineDrawing()">
                  Finish
                </app-button>
              }
              <app-button variant="ghost" size="xs" (click)="cancelDrawingFromUI()">
                Cancel
              </app-button>
            </div>
          </div>
        }
        @if (!sketchPlane) {
          <p class="hint">Select a plane to draw</p>
        }
      </div>
    </div>
  </div>
}

<!-- Add Body Panel (Floating) -->
@if (isEditMode && activePanel === 'add-body') {
  <div class="flyout-panel add-body-panel" [@slideIn] [style.left]="toolbarLeft + 'px'">
    <div class="flyout-header">
      <span class="flyout-title">Add Body</span>
      <app-button variant="icon-button" size="xs" (click)="closePanel()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width: 14px; height: 14px">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </app-button>
    </div>
    <div class="flyout-body">
      <!-- Primitives Section -->
      <div class="flyout-section">
        <div class="section-title">Primitives</div>
        <div class="primitive-grid">
          <button class="primitive-btn" [class.active]="primitiveType === 'box'" (click)="primitiveType = 'box'"
            appTooltip="Box">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path
                d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
              <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
              <line x1="12" y1="22.08" x2="12" y2="12" />
            </svg>
            <span>Box</span>
          </button>
          <button class="primitive-btn" [class.active]="primitiveType === 'cylinder'"
            (click)="primitiveType = 'cylinder'" appTooltip="Cylinder">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <ellipse cx="12" cy="5" rx="9" ry="3" />
              <path d="M21 5v14c0 1.66-4.03 3-9 3s-9-1.34-9-3V5" />
            </svg>
            <span>Cylinder</span>
          </button>
          <button class="primitive-btn" [class.active]="primitiveType === 'sphere'" (click)="primitiveType = 'sphere'"
            appTooltip="Sphere">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <circle cx="12" cy="12" r="10" />
              <ellipse cx="12" cy="12" rx="10" ry="4" />
              <line x1="12" y1="2" x2="12" y2="22" />
            </svg>
            <span>Sphere</span>
          </button>
          <button class="primitive-btn" [class.active]="primitiveType === 'ring'" (click)="primitiveType = 'ring'"
            appTooltip="Ring (Hollow Cylinder)">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <!-- Outer ellipse top -->
              <ellipse cx="12" cy="5" rx="9" ry="3" />
              <!-- Inner ellipse top (hole) -->
              <ellipse cx="12" cy="5" rx="5" ry="1.7" />
              <!-- Outer sides -->
              <path d="M21 5v14c0 1.66-4.03 3-9 3s-9-1.34-9-3V5" />
              <!-- Inner sides (hole) -->
              <path d="M17 5v14c0 .92-2.24 1.67-5 1.67s-5-.75-5-1.67V5" />
            </svg>
            <span>Ring</span>
          </button>
        </div>
        <!-- Primitive Parameters -->
        @if (primitiveType === 'box') {
          <div class="primitive-params">
            <div class="param-grid">
              <app-form-control label="Width">
                <app-input type="number" size="xs" [(ngModel)]="boxWidth" [min]="1" [step]="1"></app-input>
              </app-form-control>
              <app-form-control label="Height">
                <app-input type="number" size="xs" [(ngModel)]="boxHeight" [min]="1" [step]="1"></app-input>
              </app-form-control>
              <app-form-control label="Depth">
                <app-input type="number" size="xs" [(ngModel)]="boxDepth" [min]="1" [step]="1"></app-input>
              </app-form-control>
            </div>
          </div>
        }
        @if (primitiveType === 'cylinder') {
          <div class="primitive-params">
            <div class="param-grid">
              <app-form-control label="Radius">
                <app-input type="number" size="xs" [(ngModel)]="cylinderRadius" [min]="1" [step]="1"></app-input>
              </app-form-control>
              <app-form-control label="Height">
                <app-input type="number" size="xs" [(ngModel)]="cylinderHeight" [min]="1" [step]="1"></app-input>
              </app-form-control>
            </div>
          </div>
        }
        @if (primitiveType === 'sphere') {
          <div class="primitive-params">
            <div class="param-grid">
              <app-form-control label="Radius">
                <app-input type="number" size="xs" [(ngModel)]="sphereRadius" [min]="1" [step]="1"></app-input>
              </app-form-control>
            </div>
          </div>
        }
        @if (primitiveType === 'ring') {
          <div class="primitive-params">
            <div class="param-grid">
              <app-form-control label="Outer Radius">
                <app-input type="number" size="xs" [(ngModel)]="ringOuterRadius" [min]="2" [step]="1"></app-input>
              </app-form-control>
              <app-form-control label="Inner Radius">
                <app-input type="number" size="xs" [(ngModel)]="ringInnerRadius" [min]="1" [step]="1"></app-input>
              </app-form-control>
              <app-form-control label="Height">
                <app-input type="number" size="xs" [(ngModel)]="ringHeight" [min]="1" [step]="1"></app-input>
              </app-form-control>
            </div>
          </div>
        }
        <app-button variant="primary" size="sm" [flex]="true"
          [disabled]="isProcessing || (primitiveType === 'ring' && ringInnerRadius >= ringOuterRadius)"
          (click)="createPrimitive()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width: 14px; height: 14px">
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
          Create {{ primitiveType | titlecase }}
        </app-button>
      </div>
      <!-- Import Section -->
      <div class="flyout-section import-section">
        <div class="section-title">Import</div>
        <!-- Import from Models List -->
        @if (availableModelParts.length > 0) {
          <div class="import-from-models">
            <div class="subsection-label">From Models List</div>
            <div class="model-select-row">
              <app-select [options]="availableModelParts" [(ngModel)]="selectedModelPartId" bindLabel="name"
                bindValue="id" placeholder="Select a part..." size="sm" [disabled]="isProcessing">
              </app-select>
            </div>
            <app-button variant="primary" size="sm" [flex]="true" [disabled]="!selectedModelPartId || isProcessing"
              (click)="importFromModelsList()" appTooltip="Import selected part as editable CAD">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                style="width: 16px; height: 16px">
                <path d="M12 3v12m0 0l-4-4m4 4l4-4" />
                <path d="M2 17l.621 2.485A2 2 0 0 0 4.561 21h14.878a2 2 0 0 0 1.94-1.515L22 17" />
              </svg>
              Import to CAD
            </app-button>
          </div>
        }
        @if (availableModelParts.length > 0) {
          <div class="import-divider">
            <span>or</span>
          </div>
        }
        <!-- Import from File -->
        <div class="subsection-label">From File</div>
        <app-button variant="outline" size="sm" [flex]="true" [disabled]="isProcessing" (click)="openSTEPImport()"
          appTooltip="Import STEP file from your computer">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
            style="width: 16px; height: 16px">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="17 8 12 3 7 8" />
            <line x1="12" y1="3" x2="12" y2="15" />
          </svg>
          Import STEP File
        </app-button>
      </div>
    </div>
  </div>
}

<!-- Operations Panel (Flyout) -->
@if (isEditMode && activePanel === 'operations') {
  <div class="flyout-panel operations-panel" [@slideIn] [style.left]="toolbarLeft + 'px'">
    <div class="flyout-header">
      <span class="flyout-title">Operations</span>
      <span class="selected-count">{{ selectedCADShapeIds.size }} selected</span>
      <app-button variant="icon-button" size="xs" (click)="closePanel()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width: 14px; height: 14px">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </app-button>
    </div>
    <div class="flyout-body">
      <!-- Quick Edit Actions - Compact Row -->
      <div class="quick-edit-row">
        <button class="mini-action-btn" [disabled]="selectedCADShapeIds.size === 0" (click)="copySelected()"
          appTooltip="Copy (Ctrl+C)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
          </svg>
          <span>Copy</span>
        </button>
        <button class="mini-action-btn" [disabled]="clipboard.length === 0" (click)="pasteFromClipboard()"
          appTooltip="Paste (Ctrl+V)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
            <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
          </svg>
          <span>Paste</span>
        </button>
        <button class="mini-action-btn" [disabled]="selectedCADShapeIds.size === 0" (click)="duplicateSelected()"
          appTooltip="Duplicate (Ctrl+D)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <rect x="8" y="8" width="12" height="12" rx="2" />
            <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" />
          </svg>
          <span>Duplicate</span>
        </button>
      </div>
      <!-- Boolean Operations -->
      @if (cadShapes.length >= 2) {
        <div class="flyout-section boolean-section">
          <div class="section-title">Boolean</div>
          <!-- Body/Tool Selection (when exactly 2 shapes selected) -->
          @if (selectedCADShapeIds.size === 2) {
            <div class="body-tool-selector">
              <div class="role-row body-row">
                <span class="role-label body">Body</span>
                <div class="role-shape" [style.--shape-color]="getBooleanBodyShape()?.color || '#4a9eff'">
                  <div class="shape-dot"></div>
                  <span class="shape-name">{{ getBooleanBodyShape()?.name || 'Shape' }}</span>
                </div>
              </div>
              <button class="swap-btn" (click)="swapBooleanRoles()" appTooltip="Swap Body & Tool">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M7 16V4M7 4L3 8M7 4l4 4" />
                  <path d="M17 8v12m0 0l4-4m-4 4l-4-4" />
                </svg>
              </button>
              <div class="role-row tool-row">
                <span class="role-label tool">Tool</span>
                <div class="role-shape" [style.--shape-color]="getBooleanToolShape()?.color || '#ef4444'">
                  <div class="shape-dot"></div>
                  <span class="shape-name">{{ getBooleanToolShape()?.name || 'Shape' }}</span>
                </div>
              </div>
            </div>
          }
          <!-- Info when more than 2 shapes selected -->
          @if (selectedCADShapeIds.size > 2) {
            <div class="multi-shape-info">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 8v4M12 16h.01" />
              </svg>
              <span>First selected = Body, rest = Tools</span>
            </div>
          }
          <div class="bool-ops">
            <button class="bool-op-btn union" [disabled]="!canBoolean()" (click)="performUnion()"
              appTooltip="Union: Combine all shapes into one">
              <svg viewBox="0 0 32 32">
                <circle cx="11" cy="16" r="8" fill="currentColor" opacity="0.15" />
                <circle cx="21" cy="16" r="8" fill="currentColor" opacity="0.15" />
                <circle cx="11" cy="16" r="8" fill="none" stroke="currentColor" stroke-width="1.5" />
                <circle cx="21" cy="16" r="8" fill="none" stroke="currentColor" stroke-width="1.5" />
              </svg>
              <span>Union</span>
            </button>
            <button class="bool-op-btn subtract" [disabled]="!canBoolean()" (click)="performSubtract()"
              appTooltip="Subtract: Cut Tool from Body">
              <svg viewBox="0 0 32 32">
                <circle cx="11" cy="16" r="8" fill="currentColor" opacity="0.2" />
                <circle cx="21" cy="16" r="8" fill="none" stroke="currentColor" stroke-width="1.5"
                  stroke-dasharray="2 1.5" />
                <circle cx="11" cy="16" r="8" fill="none" stroke="currentColor" stroke-width="1.5" />
              </svg>
              <span>Subtract</span>
            </button>
            <button class="bool-op-btn intersect" [disabled]="!canBoolean()" (click)="performIntersect()"
              appTooltip="Intersect: Keep only overlapping region">
              <svg viewBox="0 0 32 32">
                <circle cx="11" cy="16" r="8" fill="none" stroke="currentColor" stroke-width="1.5" opacity="0.3" />
                <circle cx="21" cy="16" r="8" fill="none" stroke="currentColor" stroke-width="1.5" opacity="0.3" />
                <path d="M16 9.6a8 8 0 0 1 0 12.8 8 8 0 0 1 0-12.8z" fill="currentColor" opacity="0.3" />
              </svg>
              <span>Intersect</span>
            </button>
          </div>
          @if (selectedCADShapeIds.size < 2) {
            <p class="hint">Select 2+ shapes for boolean</p>
          }
        </div>
      }
      <!-- Tabbed Operations (Edge & Surface / Patterns) -->
      @if (shouldShowTabbedOperations()) {
        <div class="flyout-section tabbed-section">
          <!-- Tab Header -->
          <div class="tab-header">
            <button class="tab-btn" [class.active]="activeOperationsTab === 'edges'"
              (click)="activeOperationsTab = 'edges'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                style="width: 14px; height: 14px">
                <path d="M4 4h16v16H4z" />
                <path d="M4 4c8 0 16 8 16 16" stroke-width="2" />
              </svg>
              Edge & Surface
            </button>
            <button class="tab-btn" [class.active]="activeOperationsTab === 'patterns'"
              (click)="activeOperationsTab = 'patterns'; cleanupThickenDirectionArrow()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                style="width: 14px; height: 14px">
                <rect x="2" y="8" width="5" height="8" rx="1" />
                <rect x="9" y="8" width="5" height="8" rx="1" opacity="0.6" />
                <rect x="16" y="8" width="5" height="8" rx="1" opacity="0.3" />
              </svg>
              Patterns
            </button>
          </div>
          <!-- Active Operation Status Bar -->
          @if (activeOperation) {
            <div class="operation-status-bar">
              <span class="operation-status-text">{{ getActiveOperationStatus() }}</span>
            </div>
          }
          <!-- Edge & Surface Tab Content -->
          @if (activeOperationsTab === 'edges') {
            <div class="tab-content edge-surface-section">
              <!-- Fillet/Chamfer (consolidated) -->
              <div class="pattern-group" [class.expanded]="expandedPatternGroup === 'fillet-chamfer'" [class.active-operation]="activeOperation === 'fillet' || activeOperation === 'chamfer'">
                <div class="pattern-header" (click)="onFilletChamferPanelClick()">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M4 4h16v16H4z" />
                    <path d="M4 4c8 0 16 8 16 16" stroke-width="2" />
                  </svg>
                  <span class="pattern-label">Fillet/Chamfer</span>
                  <svg class="expand-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </div>
                @if (expandedPatternGroup === 'fillet-chamfer') {
                  <div class="pattern-controls">
                    <!-- Operation type toggle -->
                    <div class="operation-toggle">
                      <button class="op-btn" [class.active]="edgeOperation === 'fillet'"
                        (click)="edgeOperation = 'fillet'" appTooltip="Round edges">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                          style="width: 14px; height: 14px">
                          <path d="M4 4h16v16H4z" />
                          <path d="M4 4c8 0 16 8 16 16" stroke-width="2" />
                        </svg>
                        Fillet
                      </button>
                      <button class="op-btn" [class.active]="edgeOperation === 'chamfer'"
                        (click)="edgeOperation = 'chamfer'" appTooltip="Bevel edges">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                          style="width: 14px; height: 14px">
                          <path d="M4 4h16v16H4z" />
                          <path d="M4 4L20 20" stroke-width="2" />
                        </svg>
                        Chamfer
                      </button>
                    </div>
                    <!-- Edge Selection -->
                    <div class="edge-select-row">
                      <button class="edge-select-btn" [class.active]="isEdgeSelectMode"
                        [class.selected]="selectedEdges.length > 0 && !isEdgeSelectMode"
                        (click)="isEdgeSelectMode ? stopEdgeSelectMode() : startEdgeSelectMode()"
                        appTooltip="Pick specific edges">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                          style="width: 12px; height: 12px">
                          <path d="M3 3h18v18H3V3z" />
                          <path d="M3 3L21 21" stroke-dasharray="2 2" />
                        </svg>
                        @if (!isEdgeSelectMode && selectedEdges.length === 0) {
                          <span>Select Edges</span>
                        }
                        @if (isEdgeSelectMode) {
                          <span>{{ selectedEdges.length }} selected...</span>
                        }
                        @if (selectedEdges.length > 0 && !isEdgeSelectMode) {
                          <span>{{ selectedEdges.length }} edges ✓</span>
                        }
                      </button>
                      @if (selectedEdges.length > 0 && !isEdgeSelectMode) {
                        <button class="clear-edge-btn"
                          (click)="clearSelectedEdges(); $event.stopPropagation()" appTooltip="Clear edge selection">
                          ✕
                        </button>
                      }
                    </div>
                    <!-- Fillet parameters -->
                    @if (edgeOperation === 'fillet') {
                      <app-form-control label="Radius">
                        <app-input type="number" size="xs" [(ngModel)]="filletRadius" [min]="0.1" [step]="0.5"></app-input>
                      </app-form-control>
                    }
                    <!-- Chamfer parameters -->
                    @if (edgeOperation === 'chamfer') {
                      <app-form-control label="Distance">
                        <app-input type="number" size="xs" [(ngModel)]="chamferDistance" [min]="0.1" [step]="0.5"></app-input>
                      </app-form-control>
                    }
                    <!-- Apply button -->
                    <app-button variant="primary" size="xs" [flex]="true" [disabled]="!canFillet() || isEdgeSelectMode"
                (click)="activeOperation ? applyActiveOperation() : (edgeOperation === 'fillet' ? performFillet() : performChamfer())" [appTooltip]="
                selectedEdges.length > 0
                  ? (edgeOperation === 'fillet' ? 'Round ' : 'Bevel ') + selectedEdges.length + ' edge(s)'
                  : (edgeOperation === 'fillet' ? 'Round all edges' : 'Bevel all edges')
              ">
                      Apply {{ edgeOperation === 'fillet' ? 'Fillet' : 'Chamfer' }}
                    </app-button>
                  </div>
                }
              </div>
              <!-- Shell -->
              <div class="pattern-group" [class.expanded]="expandedPatternGroup === 'shell'" [class.active-operation]="activeOperation === 'shell'">
                <div class="pattern-header" (click)="onShellPanelClick()">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <rect x="3" y="3" width="18" height="18" rx="2" />
                    <rect x="6" y="6" width="12" height="12" rx="1" stroke-dasharray="2 2" />
                  </svg>
                  <span class="pattern-label">Shell</span>
                  <svg class="expand-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </div>
                @if (expandedPatternGroup === 'shell') {
                  <div class="pattern-controls">
                    <!-- Face Selection -->
                    <div class="shell-face-select">
                      <button class="face-select-btn" [class.active]="isShellFaceSelectMode"
                        [class.selected]="hasSelectedShellFace()"
                        (click)="isShellFaceSelectMode ? stopShellFaceSelectMode() : startShellFaceSelectMode()"
                        [disabled]="!canFillet()" appTooltip="Pick face to remove from shell">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                          style="width: 12px; height: 12px">
                          <rect x="3" y="3" width="18" height="18" rx="2" />
                          <path d="M9 9h6v6H9z" fill="currentColor" opacity="0.3" />
                        </svg>
                        @if (!isShellFaceSelectMode && !hasSelectedShellFace()) {
                          <span>Pick Face</span>
                        }
                        @if (isShellFaceSelectMode) {
                          <span>Picking...</span>
                        }
                        @if (hasSelectedShellFace() && !isShellFaceSelectMode) {
                          <span>Face ✓</span>
                        }
                      </button>
                      @if (hasSelectedShellFace()) {
                        <button class="clear-face-btn" (click)="clearSelectedShellFace()"
                          appTooltip="Clear face selection">
                          ✕
                        </button>
                      }
                    </div>
                    <app-form-control label="Thickness">
                      <app-input type="number" size="xs" [(ngModel)]="shellThickness" [min]="0.1" [step]="0.5"></app-input>
                    </app-form-control>
                    <app-button variant="primary" size="xs" [flex]="true" [disabled]="!canFillet() || isShellFaceSelectMode"
                      (click)="activeOperation ? applyActiveOperation() : performShell()" appTooltip="Create hollow shell">
                      Apply Shell
                    </app-button>
                  </div>
                }
              </div>
              <!-- Offset -->
              <div class="pattern-group" [class.expanded]="expandedPatternGroup === 'offset'" [class.active-operation]="activeOperation === 'offset'">
                <div class="pattern-header" (click)="onOffsetPanelClick()">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <rect x="5" y="5" width="14" height="14" rx="2" />
                    <rect x="2" y="2" width="20" height="20" rx="3" stroke-dasharray="2 2" />
                  </svg>
                  <span class="pattern-label">Offset</span>
                  <svg class="expand-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </div>
                @if (expandedPatternGroup === 'offset') {
                  <div class="pattern-controls">
                    <app-form-control label="Distance">
                      <app-input type="number" size="xs" [(ngModel)]="offsetDistance" [step]="1"></app-input>
                    </app-form-control>
                    <app-button variant="primary" size="xs" [flex]="true" [disabled]="!canFillet()"
                      (click)="activeOperation ? applyActiveOperation() : performOffset()"
                      appTooltip="Expand (+) or shrink (-) shape">
                      Apply Offset
                    </app-button>
                  </div>
                }
              </div>
              <!-- Boss/Pocket (Extrude on Face) -->
              <div class="pattern-group" [class.expanded]="expandedPatternGroup === 'boss-pocket'" [class.active-operation]="activeOperation === 'boss' || activeOperation === 'pocket'">
                <div class="pattern-header" (click)="extrudeOnFaceHeight >= 0 ? onBossPanelClick() : onPocketPanelClick()">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <rect x="3" y="10" width="18" height="10" rx="1" />
                    <rect x="8" y="4" width="8" height="6" fill="currentColor" opacity="0.3" />
                    <path d="M8 10V4h8v6" stroke-width="1.5" />
                  </svg>
                  <span class="pattern-label">Boss/Pocket</span>
                  <svg class="expand-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </div>
                @if (expandedPatternGroup === 'boss-pocket') {
                  <div class="pattern-controls">
                    <!-- Mode indicator -->
                    @if (isExtrudeOnFaceMode) {
                      <div class="boss-pocket-status">
                        <div class="status-step" [class.active]="!selectedFaceInfo">
                          <span class="step-num">1</span>
                          <span>Pick a face</span>
                        </div>
                        <div class="status-step" [class.active]="selectedFaceInfo && drawingMode === 'none'">
                          <span class="step-num">2</span>
                          <span>Draw profile</span>
                        </div>
                        <div class="status-step" [class.active]="selectedFaceInfo && drawingMode !== 'none'">
                          <span class="step-num">3</span>
                          <span>Finish drawing</span>
                        </div>
                      </div>
                    }
                    @if (!isExtrudeOnFaceMode || selectedFaceInfo) {
                      <app-form-control label="Height">
                        <app-input type="number" size="xs" [(ngModel)]="extrudeOnFaceHeight" [step]="5" (ngModelChange)="onBossPocketHeightChange()"></app-input>
                      </app-form-control>
                    }
                    @if (!isExtrudeOnFaceMode) {
                      <p class="hint">Positive = Boss (add), Negative = Pocket (cut)</p>
                    }
                    <!-- Start button -->
                    @if (!isExtrudeOnFaceMode) {
                      <app-button variant="primary" size="xs" [flex]="true"
                        [disabled]="selectedCADShapeIds.size !== 1" (click)="startExtrudeOnFaceMode(extrudeOnFaceHeight >= 0 ? 'boss' : 'pocket')"
                        [appTooltip]="extrudeOnFaceHeight >= 0 ? 'Add material (boss)' : 'Remove material (pocket)'">
                        Start {{ extrudeOnFaceHeight >= 0 ? 'Boss' : 'Pocket' }}
                      </app-button>
                    }
                    <!-- Cancel button when in mode -->
                    @if (isExtrudeOnFaceMode) {
                      <app-button variant="ghost" size="xs" [flex]="true"
                        (click)="exitOperationMode(true)">
                        Cancel
                      </app-button>
                    }
                    @if (selectedCADShapeIds.size !== 1 && !isExtrudeOnFaceMode) {
                      <p class="hint">Select 1 shape first</p>
                    }
                    @if (isExtrudeOnFaceMode && !selectedFaceInfo) {
                      <p class="hint">Click on a face to select it</p>
                    }
                    @if (isExtrudeOnFaceMode && selectedFaceInfo && drawingMode === 'none') {
                      <p class="hint">
                        Select a drawing tool (rectangle, circle, or line) to draw your profile
                      </p>
                    }
                  </div>
                }
              </div>
              <!-- Push/Pull Face -->
              <div class="pattern-group" [class.expanded]="expandedPatternGroup === 'push-pull'" [class.active-operation]="activeOperation === 'push-pull'">
                <div class="pattern-header" (click)="onPushPullPanelClick()">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <rect x="4" y="4" width="16" height="16" rx="2" />
                    <path d="M12 8v8M8 12h8" stroke-width="2" />
                  </svg>
                  <span class="pattern-label">Push/Pull</span>
                  <svg class="expand-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </div>
                @if (expandedPatternGroup === 'push-pull') {
                  <div class="pattern-controls">
                    <!-- Face Selection for Push/Pull -->
                    <div class="edge-select-row">
                      <button class="edge-select-btn" [class.active]="isPushPullMode"
                        [class.selected]="selectedPushPullFaceIndex !== null && !isPushPullMode"
                        (click)="isPushPullMode ? stopPushPullMode(false) : startPushPullMode()" [disabled]="!canFillet()"
                        appTooltip="Select face to push or pull">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                          style="width: 12px; height: 12px">
                          <rect x="3" y="3" width="18" height="18" rx="2" />
                          <path d="M9 9h6v6H9z" fill="currentColor" opacity="0.3" />
                        </svg>
                        @if (!isPushPullMode && selectedPushPullFaceIndex === null) {
                          <span>Pick Face</span>
                        }
                        @if (isPushPullMode) {
                          <span>Picking...</span>
                        }
                        @if (selectedPushPullFaceIndex !== null && !isPushPullMode) {
                          <span>Face ✓</span>
                        }
                      </button>
                      @if (selectedPushPullFaceIndex !== null && !isPushPullMode) {
                        <button class="clear-edge-btn"
                          (click)="selectedPushPullFaceIndex = null" appTooltip="Clear selection">
                          ✕
                        </button>
                      }
                    </div>
                    <app-form-control label="Distance">
                      <app-input type="number" size="xs" [(ngModel)]="pushPullDistance" [step]="5"></app-input>
                    </app-form-control>
                    <p class="hint">Positive = push out, Negative = pull in</p>
                    <app-button variant="primary" size="xs" [flex]="true" [disabled]="!canApplyPushPull() || isPushPullMode"
                      (click)="activeOperation ? applyActiveOperation() : applyPushPull()" appTooltip="Push or pull the selected face">
                      Apply Push/Pull
                    </app-button>
                  </div>
                }
              </div>
              <!-- Surface Operations -->
              <div class="pattern-group" [class.expanded]="expandedPatternGroup === 'surface'" [class.active-operation]="activeOperation === 'extract-face' || activeOperation === 'thicken'">
                <div class="pattern-header" (click)="onSurfacePanelClick()">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <!-- Surface/face extraction icon -->
                    <path d="M4 6h16v12H4z" />
                    <path d="M4 6l4-3h12l-4 3" />
                    <path d="M20 6l4-3v12l-4 3" opacity="0.5" />
                  </svg>
                  <span class="pattern-label">Surface</span>
                  <svg class="expand-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </div>
                @if (expandedPatternGroup === 'surface') {
                  <div class="pattern-controls">
                    <!-- Extract Face -->
                    <div class="surface-extract-section">
                      <!-- Face Selection -->
                      <div class="face-select-row">
                        <button class="face-select-btn" [class.active]="isExtractFacePickingMode"
                          [class.selected]="hasSelectedExtractFace() && !isExtractFacePickingMode"
                          (click)="isExtractFacePickingMode ? stopExtractFacePickingMode() : startExtractFacePickingMode()"
                          [disabled]="selectedCADShapeIds.size !== 1"
                          appTooltip="Pick specific faces to extract">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                            style="width: 12px; height: 12px">
                            <path d="M4 6h16v12H4z" />
                            <circle cx="12" cy="12" r="2" fill="currentColor" />
                          </svg>
                          @if (!isExtractFacePickingMode && !hasSelectedExtractFace()) {
                            <span>Select Faces</span>
                          }
                          @if (isExtractFacePickingMode) {
                            <span>{{ selectedExtractFaceIndices.length }} selected...</span>
                          }
                          @if (hasSelectedExtractFace() && !isExtractFacePickingMode) {
                            <span>{{ selectedExtractFaceIndices.length }} faces ✓</span>
                          }
                        </button>
                        @if (hasSelectedExtractFace() && !isExtractFacePickingMode) {
                          <button class="clear-face-btn"
                            (click)="clearSelectedExtractFace(); $event.stopPropagation()"
                            appTooltip="Clear face selection">
                            ✕
                          </button>
                        }
                      </div>
                      <app-button variant="primary" size="xs" [flex]="true"
                        [disabled]="!canExtractFace()"
                        (click)="extractSelectedFace()"
                        appTooltip="Extract the selected faces as standalone surfaces">
                        Extract {{ selectedExtractFaceIndices.length > 1 ? selectedExtractFaceIndices.length + ' Faces' : 'Face' }}
                      </app-button>
                      <app-button variant="outline" size="xs" [flex]="true"
                        [disabled]="!canExtractFaceWires()"
                        (click)="extractFaceWiresToSketch()"
                        appTooltip="Create a sketch from the selected face boundary">
                        Extract Wires to Sketch
                      </app-button>
                      @if (hasSelectedExtractFace() && selectedExtractFaceIndices.length !== 1) {
                        <p class="hint">
                          Select exactly 1 face to extract wires
                        </p>
                      }
                      @if (selectedCADShapeIds.size !== 1) {
                        <p class="hint">Select 1 shape first</p>
                      }
                    </div>
                    <!-- Thicken Surface (only shown if surfaces are selected) -->
                    @if (canThickenSurface()) {
                      <div class="surface-thicken-section">
                        <div class="operation-divider">
                          <span class="divider-line"></span>
                          <span class="divider-label">Thicken</span>
                          <span class="divider-line"></span>
                        </div>
                        @if (getSelectedSurfaceCount() > 0) {
                          <div class="surface-count-badge">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                              <path d="M4 6h16v12H4z" />
                            </svg>
                            {{ getSelectedSurfaceCount() }} surface{{ getSelectedSurfaceCount() > 1 ? 's' : '' }} selected
                          </div>
                        }
                        <app-form-control label="Thickness">
                          <app-input type="number" size="xs" [(ngModel)]="thickenAmount" [step]="0.5"
                          (ngModelChange)="updateThickenDirectionArrow()"></app-input>
                        </app-form-control>
                        <app-button variant="primary" size="xs" [flex]="true"
                          [disabled]="thickenAmount === 0"
                          (click)="thickenSelectedSurface()"
                          appTooltip="Thicken the selected surfaces into solids. Positive = outward, Negative = inward">
                          Thicken {{ getSelectedSurfaceCount() > 1 ? getSelectedSurfaceCount() + ' Surfaces' : 'Surface' }}
                        </app-button>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
          <!-- Patterns Tab Content -->
          @if (activeOperationsTab === 'patterns') {
            <div class="tab-content pattern-section">
              <!-- Linear Array -->
              <div class="pattern-group" [class.expanded]="expandedPatternGroup === 'linear-array'">
                <div class="pattern-header" (click)="togglePatternGroup('linear-array')">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <rect x="2" y="8" width="5" height="8" rx="1" />
                    <rect x="9" y="8" width="5" height="8" rx="1" opacity="0.6" />
                    <rect x="16" y="8" width="5" height="8" rx="1" opacity="0.3" />
                    <path d="M7 12h2M14 12h2" stroke-dasharray="1 1" />
                  </svg>
                  <span class="pattern-label">Linear Array</span>
                  <svg class="expand-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </div>
                @if (expandedPatternGroup === 'linear-array') {
                  <div class="pattern-controls">
                    <app-form-control label="Direction">
                      <app-select [(ngModel)]="linearArrayDirection" [options]="axisOptions" bindValue="value"
                        bindLabel="label" size="xs" placeholder="Select axis">
                      </app-select>
                    </app-form-control>
                    <div class="param-grid two-col">
                      <app-form-control label="Count">
                        <app-input type="number" size="xs" [(ngModel)]="linearArrayCount" [min]="2" [max]="50"
                        [step]="1"></app-input>
                      </app-form-control>
                      <app-form-control label="Spacing">
                        <app-input type="number" size="xs" [(ngModel)]="linearArraySpacing" [min]="0.1"
                        [step]="1"></app-input>
                      </app-form-control>
                    </div>
                    <app-button variant="primary" size="xs" [flex]="true" [disabled]="!canApplyLinearArray()"
                      (click)="applyLinearArray()" appTooltip="Create linear pattern">
                      Create Array
                    </app-button>
                  </div>
                }
              </div>
              <!-- Circular Array -->
              <div class="pattern-group" [class.expanded]="expandedPatternGroup === 'circular-array'">
                <div class="pattern-header" (click)="togglePatternGroup('circular-array')">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <circle cx="12" cy="12" r="8" stroke-dasharray="2 2" />
                    <rect x="10" y="2" width="4" height="4" rx="1" />
                    <rect x="18" y="10" width="4" height="4" rx="1" opacity="0.6" />
                    <rect x="10" y="18" width="4" height="4" rx="1" opacity="0.4" />
                    <rect x="2" y="10" width="4" height="4" rx="1" opacity="0.2" />
                  </svg>
                  <span class="pattern-label">Circular Array</span>
                  <svg class="expand-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </div>
                @if (expandedPatternGroup === 'circular-array') {
                  <div class="pattern-controls">
                    <div class="param-grid two-col">
                      <app-form-control label="Axis">
                        <app-select [(ngModel)]="circularArrayAxis" [options]="axisOptions" bindValue="value"
                          bindLabel="label" size="xs" placeholder="Select axis">
                        </app-select>
                      </app-form-control>
                      <app-form-control label="Count">
                        <app-input type="number" size="xs" [(ngModel)]="circularArrayCount" [min]="2" [max]="50"
                        [step]="1"></app-input>
                      </app-form-control>
                    </div>
                    <app-form-control label="Angle (°)">
                      <app-input type="number" size="xs" [(ngModel)]="circularArrayAngle" [min]="1" [max]="360"
                      [step]="15"></app-input>
                    </app-form-control>
                    <app-button variant="primary" size="xs" [flex]="true" [disabled]="!canApplyCircularArray()"
                      (click)="applyCircularArray()" appTooltip="Create circular pattern around axis">
                      Create Array
                    </app-button>
                  </div>
                }
              </div>
              <!-- Mirror -->
              <div class="pattern-group mirror-group" [class.expanded]="expandedPatternGroup === 'mirror'">
                <div class="pattern-header" (click)="togglePatternGroup('mirror')">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M12 3v18" stroke-dasharray="3 2" />
                    <rect x="3" y="7" width="6" height="10" rx="1" />
                    <rect x="15" y="7" width="6" height="10" rx="1" opacity="0.5" />
                  </svg>
                  <span class="pattern-label">Mirror</span>
                  <svg class="expand-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </div>
                @if (expandedPatternGroup === 'mirror') {
                  <div class="pattern-controls">
                    <div class="mirror-plane-selector">
                      <button class="mirror-plane-btn" [class.active]="mirrorPlane === 'YZ'" (click)="mirrorPlane = 'YZ'"
                        appTooltip="Mirror across YZ plane (flip in X)">
                        YZ
                      </button>
                      <button class="mirror-plane-btn" [class.active]="mirrorPlane === 'XZ'" (click)="mirrorPlane = 'XZ'"
                        appTooltip="Mirror across XZ plane (flip in Y)">
                        XZ
                      </button>
                      <button class="mirror-plane-btn" [class.active]="mirrorPlane === 'XY'" (click)="mirrorPlane = 'XY'"
                        appTooltip="Mirror across XY plane (flip in Z)">
                        XY
                      </button>
                    </div>
                    <app-button variant="primary" size="xs" [flex]="true" [disabled]="selectedCADShapeIds.size !== 1"
                      (click)="applyMirror()" appTooltip="Mirror selected shape">
                      Mirror
                    </app-button>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
      <!-- Measurements -->
      @if (selectedCADShapeIds.size >= 1) {
        <div class="flyout-section measurements">
          <div class="section-title">Measurements</div>
          <!-- Single Shape -->
          @if (selectedCADShapeIds.size === 1 && measurementInfo.boundingBox) {
            <div class="measure-grid">
              <div class="measure-item">
                <span class="measure-label">X</span>
                <span class="measure-value">{{ formatNumber(measurementInfo.boundingBox.size[0]) }}</span>
              </div>
              <div class="measure-item">
                <span class="measure-label">Y</span>
                <span class="measure-value">{{ formatNumber(measurementInfo.boundingBox.size[1]) }}</span>
              </div>
              <div class="measure-item">
                <span class="measure-label">Z</span>
                <span class="measure-value">{{ formatNumber(measurementInfo.boundingBox.size[2]) }}</span>
              </div>
            </div>
            @if (measurementInfo.volume !== undefined) {
              <div class="measure-row">
                <span class="measure-label">Volume</span>
                <span class="measure-value">{{ measurementInfo.volume | unit:'volume':unitSystem() }}</span>
              </div>
            }
          }
          <!-- Two Shapes -->
          @if (selectedCADShapeIds.size === 2 && measurementInfo.distanceBetween !== undefined) {
            <div class="measure-row highlight"
              >
              <span class="measure-label">Distance</span>
              <span class="measure-value">{{ measurementInfo.distanceBetween | unit:'length':unitSystem() }}</span>
            </div>
          }
        </div>
      }
    </div>
  </div>
}

<!-- History Panel (Flyout) -->
@if (isEditMode && activePanel === 'history') {
  <div class="flyout-panel history-panel" [@slideIn] [style.left]="toolbarLeft + 'px'">
    <div class="flyout-header">
      <span class="flyout-title">History</span>
      <app-button variant="icon-button" size="xs" (click)="closePanel()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width: 14px; height: 14px">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </app-button>
    </div>
    <div class="flyout-body">
      <div class="history-actions">
        <app-button variant="ghost" size="xs" [flex]="true" [disabled]="!canUndo" (click)="undoHistory()">
          Undo
        </app-button>
        <app-button variant="ghost" size="xs" [flex]="true" [disabled]="!canRedo" (click)="redoHistory()">
          Redo
        </app-button>
      </div>
      @if (historyOperations.length === 0) {
        <div class="history-empty">
          No history yet
        </div>
      }
      @if (historyOperations.length > 0) {
        <div class="history-list">
          @for (operation of historyOperations; track operation; let i = $index) {
            <div class="history-item"
              [class.active]="i === historyIndex" [class.future]="i > historyIndex">
              <span class="history-index">{{ i + 1 }}</span>
              <span class="history-label">{{ getHistoryLabel(operation) }}</span>
            </div>
          }
        </div>
      }
    </div>
  </div>
}

<!-- Context Menu -->
@if (showContextMenu) {
  <div class="context-menu" [style.left.px]="contextMenuPosition.x"
    [style.top.px]="contextMenuPosition.y" (mouseleave)="closeContextMenu()">
    <button class="context-menu-item" (click)="onContextMenuAction('rename')">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
      </svg>
      <span>Rename</span>
      <span class="shortcut">Double-click</span>
    </button>
    <div class="context-menu-divider"></div>
    <button class="context-menu-item" (click)="onContextMenuAction('copy')">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
      </svg>
      <span>Copy</span>
      <span class="shortcut">Ctrl+C</span>
    </button>
    <button class="context-menu-item" (click)="onContextMenuAction('duplicate')">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="8" y="8" width="12" height="12" rx="2" />
        <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" />
      </svg>
      <span>Duplicate</span>
      <span class="shortcut">Ctrl+D</span>
    </button>
    <div class="context-menu-divider"></div>
    <button class="context-menu-item" (click)="onContextMenuAction('isolate')">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10" />
        <circle cx="12" cy="12" r="4" />
      </svg>
      <span>Isolate</span>
    </button>
    <button class="context-menu-item" (click)="showAllShapes(); closeContextMenu()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
      <span>Show All</span>
    </button>
    <div class="context-menu-divider"></div>
    <button class="context-menu-item danger" (click)="onContextMenuAction('delete')">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      </svg>
      <span>Delete</span>
      <span class="shortcut">Del</span>
    </button>
  </div>
}

<!-- Snap Feedback Label -->
@if (snapFeedbackLabel) {
  <div class="snap-feedback-label" [style.left.px]="snapFeedbackPosition.x"
    [style.top.px]="snapFeedbackPosition.y" [style.color]="snapFeedbackColor"
    [style.border-color]="snapFeedbackColor" [style.box-shadow]="'0 0 8px ' + snapFeedbackColor + '40'">
    {{ snapFeedbackLabel }}
  </div>
}

<!-- Drawing Dimensions Display (follows cursor) -->
<!-- Drawing Dimensions Tooltip -->
@if (drawingDimensions && drawingMode !== 'none') {
  <div class="drawing-dimensions"
    [style.left.px]="drawingDimensionsPosition.x" [style.top.px]="drawingDimensionsPosition.y">
    <!-- Rectangle: W × H -->
    @if (drawingMode === 'rectangle') {
      <div class="dim-row">
        <span class="dim-value">{{ drawingDimensions.width | number:'1.0-1' }}</span>
        <span class="dim-sep">×</span>
        <span class="dim-value">{{ drawingDimensions.height | number:'1.0-1' }}</span>
      </div>
    }
    <!-- Circle: Diameter -->
    @if (drawingMode === 'circle') {
      <div class="dim-row">
        <span class="dim-label">⌀</span>
        <span class="dim-value">{{ drawingDimensions.width | number:'1.0-1' }}</span>
      </div>
    }
    <!-- Polygon: Diameter + Sides -->
    @if (drawingMode === 'polygon') {
      <div class="dim-row">
        <span class="dim-label">⌀</span>
        <span class="dim-value">{{ drawingDimensions.width | number:'1.0-1' }}</span>
        <span class="dim-sep">·</span>
        <span class="dim-sides">{{ polygonSides }}-gon</span>
      </div>
    }
    <!-- Arc: Length -->
    @if (drawingMode === 'arc') {
      <div class="dim-row">
        <span class="dim-label">↷</span>
        <span class="dim-value">{{ drawingDimensions.width | number:'1.0-1' }}</span>
      </div>
    }
    <!-- Slot: Length × Width -->
    @if (drawingMode === 'slot') {
      <div class="dim-row">
        <span class="dim-value">{{ drawingDimensions.width | number:'1.0-1' }}</span>
        <span class="dim-sep">×</span>
        <span class="dim-value">{{ drawingDimensions.height | number:'1.0-1' }}</span>
        <span class="dim-unit">(L×W)</span>
      </div>
    }
    <!-- Tab hint -->
    @if (!showDimensionInput) {
      <div class="dim-hint">
        <kbd>Tab</kbd> to type
      </div>
    }
  </div>
}

<!-- Dimension Input Overlay (Tab to activate) -->
@if (showDimensionInput) {
  <div class="dimension-input-overlay" [style.left.px]="dimensionInputPosition.x"
    [style.top.px]="dimensionInputPosition.y">
    <div class="dim-input-container">
      @if (drawingMode === 'rectangle') {
        <div class="dim-input-row">
          <div class="dim-input-field">
            <label>W</label>
            <input type="number" #widthInput [(ngModel)]="dimensionInputWidth" (ngModelChange)="onDimensionInputChange()"
              (keydown.enter)="applyDimensionInput()" (keydown.escape)="closeDimensionInput()" placeholder="Width"
              autofocus>
          </div>
          <span class="dim-sep">×</span>
          <div class="dim-input-field">
            <label>H</label>
            <input type="number" #heightInput [(ngModel)]="dimensionInputHeight"
              (ngModelChange)="onDimensionInputChange()" (keydown.enter)="applyDimensionInput()"
              (keydown.escape)="closeDimensionInput()" placeholder="Height">
          </div>
        </div>
      }
      @if (drawingMode === 'circle' || drawingMode === 'polygon') {
        <div class="dim-input-row">
          <div class="dim-input-field">
            <label>⌀</label>
            <input type="number" [(ngModel)]="dimensionInputDiameter" (ngModelChange)="onDimensionInputChange()"
              (keydown.enter)="applyDimensionInput()" (keydown.escape)="closeDimensionInput()" placeholder="Diameter (⌀)"
              autofocus>
          </div>
        </div>
      }
      @if (drawingMode === 'slot') {
        <div class="dim-input-row">
          <div class="dim-input-field">
            <label>L</label>
            <input type="number" [(ngModel)]="dimensionInputWidth" (ngModelChange)="onDimensionInputChange()"
              (keydown.enter)="applyDimensionInput()" (keydown.escape)="closeDimensionInput()" placeholder="Length"
              autofocus>
          </div>
          <span class="dim-sep">×</span>
          <div class="dim-input-field">
            <label>W</label>
            <input type="number" [(ngModel)]="slotWidth" (ngModelChange)="onDimensionInputChange()"
              (keydown.enter)="applyDimensionInput()" (keydown.escape)="closeDimensionInput()" placeholder="Width">
          </div>
        </div>
      }
      <div class="dim-input-actions">
        <button class="dim-apply-btn" (click)="applyDimensionInput()" appTooltip="Apply (Enter)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </button>
        <button class="dim-cancel-btn" (click)="closeDimensionInput()" appTooltip="Cancel (Esc)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    </div>
  </div>
}

<!-- Boss/Pocket Floating Tool Picker -->
@if (showBossPocketToolPicker) {
  <div class="boss-pocket-tool-picker"
    [style.left.px]="bossPocketToolPickerPosition.x"
    [style.top.px]="bossPocketToolPickerPosition.y">
    <div class="tool-picker-header">
      <span>Select Drawing Tool</span>
      <button class="tool-picker-close" (click)="closeBossPocketToolPicker()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
    <div class="tool-picker-grid">
      <button class="tool-picker-btn" (click)="selectBossPocketTool('rectangle')" appTooltip="Draw Rectangle">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <rect x="3" y="5" width="18" height="14" rx="1" />
        </svg>
        <span>Rectangle</span>
      </button>
      <button class="tool-picker-btn" (click)="selectBossPocketTool('circle')" appTooltip="Draw Circle">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <circle cx="12" cy="12" r="9" />
        </svg>
        <span>Circle</span>
      </button>
      <button class="tool-picker-btn" (click)="selectBossPocketTool('polygon')" appTooltip="Draw Polygon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <polygon points="12,2 22,8.5 19,20 5,20 2,8.5" />
        </svg>
        <span>Polygon</span>
      </button>
      <button class="tool-picker-btn" (click)="selectBossPocketTool('line')" appTooltip="Draw Freeform">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M3 17l6-6 4 4 8-8" />
          <circle cx="3" cy="17" r="1.5" fill="currentColor" />
          <circle cx="9" cy="11" r="1.5" fill="currentColor" />
          <circle cx="13" cy="15" r="1.5" fill="currentColor" />
          <circle cx="21" cy="7" r="1.5" fill="currentColor" />
        </svg>
        <span>Lines</span>
      </button>
    </div>
  </div>
}
